export const NoParticipantsIcon = () => {
  return (
    <svg width='210' height='126' viewBox='0 0 210 126' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <circle cx='15' cy='15' r='13' stroke='#CCCCCC' stroke-width='4' stroke-dasharray='6 6' />
      <circle cx='15' cy='63' r='13' stroke='#CCCCCC' stroke-width='4' stroke-dasharray='6 6' />
      <circle cx='15' cy='111' r='13' stroke='#CCCCCC' stroke-width='4' stroke-dasharray='6 6' />
      <rect x='47' y='2' width='161' height='26' rx='13' stroke='#CCCCCC' stroke-width='4' stroke-dasharray='6 6' />
      <rect x='47' y='50' width='161' height='26' rx='13' stroke='#CCCCCC' stroke-width='4' stroke-dasharray='6 6' />
      <rect x='47' y='98' width='78' height='26' rx='13' stroke='#CCCCCC' stroke-width='4' stroke-dasharray='6 6' />
    </svg>
  );
};
